/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Funnel_Footer_CopyrightInputs */

const en_funnel_footer_copyright = /** @type {(inputs: Funnel_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Listening.com`)
};

const es_funnel_footer_copyright = /** @type {(inputs: Funnel_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Listening.com`)
};

/**
* | output |
* | --- |
* | "© {year} Listening.com" |
*
* @param {Funnel_Footer_CopyrightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_footer_copyright = /** @type {((inputs: Funnel_Footer_CopyrightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Footer_CopyrightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_footer_copyright(inputs)
	return en_funnel_footer_copyright(inputs)
});